import React from 'react';
import {Outlet} from "react-router-dom";

function Uninitialized() {
    return (
        <div className="h-full">
            <Outlet/>
        </div>
    );
}

export default Uninitialized;